import React, { useEffect, useContext } from "react";
import axios from "axios";
import * as Yup from "yup";
import toast from "react-hot-toast";
import ProfileLeftSidebar from "./ProfileLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../components/PageHeaderWithBreadcrumbs";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { AuthContext } from "../../helpers/AuthContext";
import { useHistory } from "react-router-dom";
import {
  buildCurrentPasswordSchema,
  buildNewPasswordSchema,
} from "../../helpers/passwordValidation";

const PASSWORD_CHANGE_TOAST_DURATION = 4000;

function ChangePassword() {
  let history = useHistory();
  const { authState } = useContext(AuthContext);

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    }
  }, [authState.id, history]);

  const changePassword = async (data, { resetForm, setSubmitting }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/change-password`,
        {
          oldPassword: data.old_password,
          newPassword: data.new_password,
        },
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      );

      if (response?.data?.error) {
        toast.error(response.data.error, {
          duration: PASSWORD_CHANGE_TOAST_DURATION,
        });
        return;
      }

      toast.success(response?.data?.success || "Password changed successfully.", {
        duration: PASSWORD_CHANGE_TOAST_DURATION,
      });
      resetForm();
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to change password.",
        {
          duration: PASSWORD_CHANGE_TOAST_DURATION,
        }
      );
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object().shape({
    old_password: buildCurrentPasswordSchema(),
    new_password: buildNewPasswordSchema(),
  });

  const initialValues = {
    old_password: "",
    new_password: ""
  };

  return (
    <div className="instance-dashboard">
      <ProfileLeftSidebar />
      <div className="rightSide place-items-top">
        <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <PageHeaderWithBreadcrumbs
              title="Change password"
              breadcrumb="Change password"
              includeButton={false}
            />
            <Formik
              initialValues={initialValues}
              onSubmit={changePassword}
              validationSchema={validationSchema}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="options options-no-header">
                    <div className="lead-selection-section" tabIndex="0">
                      <ErrorMessage name="old_password" component="span" />
                      <Field
                          type="password"
                          placeholder="Your current password"
                          name="old_password"
                          autoComplete="current-password"
                        />
                        <ErrorMessage name="new_password" component="span" />
                        <Field
                          type="password"
                          placeholder="New password"
                          name="new_password"
                          autoComplete="new-password"
                        />
                    </div>
                  </div>
                  <button
                    className="core-design-save-changes"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save changes"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
